module.exports = __webpack_public_path__ + "img/logo.1a40c41d.png";